<nz-modal
    [nzFooter]="null"
    [nzVisible]="visible"
    [nzMaskClosable]="false"
    [nzClosable]="false"
    [nzAutofocus]="null"
    nzClassName="migration-notice-popup"
    nzCentered
    nzWidth="560px">
    <div *nzModalContent class="migration-notice">
        <div class="migration-notice__badge">Important Update</div>
        <h2>Welcome to CreativeHubInternational.com</h2>
        <p>
            We have officially updated our name from chisolution.com. Your account, login details, and active projects are
            entirely safe. Please update your bookmarks to our new home.
        </p>
        <div class="migration-notice__footer">
            <button nz-button nzType="primary" nzSize="large" type="button" (click)="onAcknowledge()">Got it</button>
        </div>
    </div>
</nz-modal>
